/**
 * Helper method used to process screenshots captured by the {@code ScreenshotCaptureEffect}.
 *
 * @param {Blob} imageBlob - The blob of the screenshot that has to be processed.
 * @param {Object} options - Custom options required for processing.
 * @returns {Promise<void>}
 */
// @ts-ignore
export async function processScreenshot(_imageBlob, _options) {
    return await Promise.resolve();
}
